import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Home = {template : ''};
const Info = {template :
   `<div>
      <br/>
        <b>TODO it!</b>
        <br>©ddamddi All Rights Reserved
        <br/>Blog : ddamddi.github.io
        <br/>Github : github.com/ddamddi
        <br/>Email : leonardkkh@gmail.com</div>`};

export default new Router({
  mode: 'history',
  routes: [
    { path: '/vuejs_todolist', name: 'Home', component: Home },
    { path: '/info', name: 'Info', component: Info}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js